angular.module('bmsApp.fees')
	.controller('FeeIndexCtrl', [
		'$log',
		'$state',
		'$scope',
		'FeeSvc',
		'notify',
		'$ngBootbox',
		'ngTableParams',
		'TaxHelperSvc',
		'FranchiseSvc',
		'$localStorage',
		'InstanceSvc',
		function ($log,
				  $state,
				  $scope,
				  FeeSvc,
				  notify,
				  $ngBootbox,
				  ngTableParams,
				  TaxHelperSvc,
				  FranchiseSvc,
				  $localStorage,
				  InstanceSvc) {

			var defaultTableParams = function () {
				return {
					page: 1, // show first page
					count: $scope.config.table.params.count, // count per page
					sorting: {
						date: 'desc' // initial sorting
					},
					filter: {}
				};
			};

			var restoreUnSubmittedExpenses = function () {
				if (angular.isDefined($localStorage.unsubmittedFeesCollection)) {

					angular.forEach(self.unsubmittedFeesCollection, function (fee, key) {
						angular.forEach($localStorage.unsubmittedFeesCollection, function (localFee, key2) {

							if (fee.date == localFee.date && fee.license_number == localFee.license_number && angular.isDefined(localFee.expenses)) {
								self.unsubmittedFeesCollection[key] = localFee;
								reCalcWithDeductions(fee);
							}
						});
					});
				}
				if (angular.isDefined($localStorage.unsubmittedSmComFeesCollection)) {

					angular.forEach(self.unsubmittedSmComFeesCollection, function (fee, key) {
						angular.forEach($localStorage.unsubmittedSmComFeesCollection, function (localFee, key2) {

							if (fee.date == localFee.date && fee.license_number == localFee.license_number && angular.isDefined(localFee.expenses)) {
								self.unsubmittedSmComFeesCollection[key] = localFee;
								reCalcWithDeductions(fee);
							}
						});
					});
				}
			};

			var restoreUnSubmittedLicenceExpenses = function () {
				if (angular.isDefined($localStorage.unsubmittedCollection)) {
					angular.forEach(self.unsubmittedCollection, function (fee, key) {
						angular.forEach($localStorage.unsubmittedCollection, function (localFee, key2) {

							if (key == key2) {
								self.unsubmittedCollection[key] = localFee;
								updateSlidingPercentFee(fee);
							}
						});
					});
				}
			};


			function init() {

				FranchiseSvc.read()
					.then((response) => {
						self.feeMethod = response.data.franchise.current_instance.licence_type.fee_method;
						self.scales = response.data.franchise.current_instance.licence_type.fee_scales;
						self.isSMRestore = InstanceSvc.instance.hasSubNetwork('SMR');
						self.hasSMResLicense = InstanceSvc.instance.hasSubNetwork('RS');
						self.hasSMComLicense = InstanceSvc.instance.hasSubNetwork('CM');
						self.hasFlatFee = InstanceSvc.instance.hasFeeMethod('flat_fee');
						self.hasFixedPercentageFee = InstanceSvc.instance.hasFeeMethod('fixed_percentage');
						self.hasSlidingPercentFee = InstanceSvc.instance.hasFeeMethod('sliding_percent');
						console.log('hasSlidingPercentFee: ' + self.hasSlidingPercentFee);
						console.log('hasFlatFee: ' + self.hasFlatFee);
						console.log('hasFixedPercentageFee: ' + self.hasFixedPercentageFee);
						console.log('----------------');
						console.log('isMM: ' + InstanceSvc.instance.isMM());
						console.log('isTG: ' + InstanceSvc.instance.isTG());
						console.log('isCS: ' + InstanceSvc.instance.isCS());
						console.log('isRB: ' + InstanceSvc.instance.isRB());
						console.log('----------------');
						// console.log('isFM: ' + InstanceSvc.instance.isFM());
						console.log('hasSMResLicense: ' + self.hasSMResLicense);
						console.log('hasSMComLicense: ' + self.hasSMComLicense);
						console.log('isSMRestore: ' + self.isSMRestore);

						var approvedParams = defaultTableParams();
						angular.extend(approvedParams.filter, {
							approved: true
						});

						var inProgressParams = defaultTableParams();
						angular.extend(inProgressParams.filter, {
							inProgress: true
						});

						if (self.hasSlidingPercentFee && !self.hasSMComLicense) {
							self.loading.unsubmitted = true;
							FeeSvc.unsubmitted()
								.then(function (response) {
									self.unsubmittedCollection = [];

									self.unsubmittedCollection = _.groupBy(response.data.fees_collection, function (fee) {
										return fee.date;
									});
									// restore previously entered data from local storage
									restoreUnSubmittedLicenceExpenses();
									self.counts.unsubmitted = response.data.fees_collection;
									self.loading.unsubmitted = false;
								});

							var inProgressSlidingFeeParams = defaultTableParams();
							angular.extend(inProgressSlidingFeeParams.filter,{
								fee_method_value: 'sliding_percent',
								inProgress: true,
							})

							self.inProgressSlidingFeeTableParams = new ngTableParams(inProgressSlidingFeeParams, {
								total: 0, // length of data
								counts: $scope.config.table.settings.counts, // available page counts
								getData: function ($defer, params) {
									self.loading.inProgressSlidingFee = true;
									FeeSvc.index(params.$params)
										.then(function (response) {
											params.total(response.data.previous_fees_filtered_count);
											self.counts.inProgressSlidingFee = response.data.previous_fees_filtered_count;
											$defer.resolve(response.data.previous_fees_collection);
											self.loading.inProgressSlidingFee = false;
										});
								}
							});

							var approvedSlidingFeeParams = defaultTableParams();
							angular.extend(approvedSlidingFeeParams.filter,{
								fee_method_value: 'sliding_percent',
								approved: true,
							});

							self.approvedSlidingFeeTableParams = new ngTableParams(approvedSlidingFeeParams, {
								total: 0, // length of data
								counts: $scope.config.table.settings.counts, // available page counts
								getData: function ($defer, params) {
									self.loading.approvedSlidingFee = true;
									FeeSvc.index(params.$params)
										.then(function (response) {
											params.total(response.data.previous_fees_filtered_count);
											self.counts.approvedSlidingFee = response.data.previous_fees_filtered_count;
											$defer.resolve(response.data.previous_fees_collection);
											self.loading.approvedSlidingFee = false;
										});
								}
							});
						}

						if (self.hasFlatFee) {
							self.approvedFlatFeeTableParams = new ngTableParams(approvedParams, {
								total: 0, // length of data
								counts: $scope.config.table.settings.counts, // available page counts
								getData: function ($defer, params) {
									self.loading.approvedFlatFee = true;
									FeeSvc.index(params.$params)
										.then(function (response) {
											params.total(response.data.previous_fees_filtered_count);
											self.counts.approvedFlatFees = response.data.previous_fees_filtered_count;
											$defer.resolve(response.data.previous_fees_collection);
											self.loading.approvedFlatFee = false;
										});
								}
							});
						}

						if (self.hasFixedPercentageFee) {

							var unSubmittedFixedPercentageFeeParams = defaultTableParams();
							angular.extend(unSubmittedFixedPercentageFeeParams.filter,{
								fee_method_value: 'fixed_percentage',
							})

							self.unsubmittedTableParams = new ngTableParams(unSubmittedFixedPercentageFeeParams, {
								total: 0, // length of data
								counts: [], // available page counts
								getData: function ($defer, params) {
									self.loading.unsubmitted = true;
									FeeSvc.unsubmitted(params.$params)
										.then(function (response) {
											params.total(response.data.fees_filtered_count);
											self.counts.unsubmitted = response.data.fees_filtered_count;
											self.unsubmittedFeesCollection = response.data.fees_collection;
											restoreUnSubmittedExpenses();
											$defer.resolve(response.data.fees_collection);
											self.loading.unsubmitted = false;
										});
								}
							});

							var submittedFixedPercentageFeeParams = defaultTableParams();
							angular.extend(submittedFixedPercentageFeeParams.filter,{
								fee_method_value: 'fixed_percentage',
								inProgress: true,
							})

							self.inProgressTableParams = new ngTableParams(submittedFixedPercentageFeeParams, {
								total: 0, // length of data
								counts: $scope.config.table.settings.counts, // available page counts
								getData: function ($defer, params) {
									self.loading.inProgress = true;
									FeeSvc.index(params.$params)
										.then(function (response) {
											params.total(response.data.previous_fees_filtered_count);
											self.counts.inProgress = response.data.previous_fees_filtered_count;
											$defer.resolve(response.data.previous_fees_collection);
											self.loading.inProgress = false;
										});
								}
							});

							var approvedFixedPercentageFeeParams = defaultTableParams();
							angular.extend(approvedFixedPercentageFeeParams.filter,{
								fee_method_value: 'fixed_percentage',
								approved: true,
							});

							self.approvedTableParams = new ngTableParams(approvedFixedPercentageFeeParams, {
								total: 0, // length of data
								counts: $scope.config.table.settings.counts, // available page counts
								getData: function ($defer, params) {
									self.loading.approved = true;
									FeeSvc.index(params.$params)
										.then(function (response) {
											params.total(response.data.previous_fees_filtered_count);
											self.counts.approved = response.data.previous_fees_filtered_count;
											$defer.resolve(response.data.previous_fees_collection);
											self.loading.approved = false;
										});
								}
							});

						}

						// SM Commercial License is special type of fee method (invoice + sliding)
						if (self.hasSMComLicense) {

							var unsubmittedSmComFeeTableParams = defaultTableParams();
							angular.extend(unsubmittedSmComFeeTableParams, {
								sub_license_type: 'CM',
							});

							self.unsubmittedSmComFeeTableParams = new ngTableParams(unsubmittedSmComFeeTableParams, {
								total: 0, // length of data
								counts: [], // available page counts
								getData: function ($defer, params) {
									self.loading.unsubmittedSmComFee = true;
									FeeSvc.unsubmitted(params.$params)
										.then(function (response) {
											params.total(response.data.fees_filtered_count);
											self.counts.unsubmittedSmComFee = response.data.fees_filtered_count;
											self.unsubmittedSmComFeesCollection = response.data.fees_collection;
											restoreUnSubmittedExpenses();
											angular.forEach(response.data.fees_collection, (fee) => {
												reCalcWithDeductions(fee);
											});
											$defer.resolve(response.data.fees_collection);
											self.loading.unsubmittedSmComFee = false;
										});
								}
							});

							var inProgressSmComFeeTableParams = angular.copy(inProgressParams);
							angular.extend(inProgressSmComFeeTableParams, {
								filter: {
									inProgress: true,
									SubLicenseTypeValue: 'CM',
								},
							});

							self.inProgressSmComFeeTableParams = new ngTableParams(inProgressSmComFeeTableParams, {
								total: 0, // length of data
								counts: $scope.config.table.settings.counts, // available page counts
								getData: function ($defer, params) {
									self.loading.inProgressSmComFee = true;
									FeeSvc.index(params.$params)
										.then(function (response) {
											params.total(response.data.previous_fees_filtered_count);
											self.counts.inProgressSmComFee = response.data.previous_fees_filtered_count;
											$defer.resolve(response.data.previous_fees_collection);
											self.loading.inProgressSmComFee = false;
										});
								}
							});

							var approvedSmComFeeTableParams = angular.copy(approvedParams);
							angular.extend(approvedSmComFeeTableParams, {
								filter: {
									SubLicenseTypeValue: 'CM',
									approved: true,
								},
							});

							self.approvedSmComFeeTableParams = new ngTableParams(approvedSmComFeeTableParams, {
								total: 0, // length of data
								counts: $scope.config.table.settings.counts, // available page counts
								getData: function ($defer, params) {
									self.loading.approvedSmComFee = true;
									FeeSvc.index(params.$params)
										.then(function (response) {
											params.total(response.data.previous_fees_filtered_count);
											self.counts.approvedSmComFee = response.data.previous_fees_filtered_count;
											$defer.resolve(response.data.previous_fees_collection);
											self.loading.approvedSmComFee = false;
										});
								}
							});

						}

					});
			}

			function reject(fee) {
				if (angular.isArray(fee.breakdown) && fee.breakdown.length && fee.status !== 'Declined') {
					$ngBootbox.confirm('Are you sure you want to cancel this submission? This will also cancel other submissions in the same group')
						.then(function () {
							_reject(fee);
						});
				}
				else {
					_reject(fee);
				}
			}

			function _reject(fee) {
				self.errors = null;
				return FeeSvc.rejectFee(fee)
					.then(function (response) {
						reloadTables();
					}, function (errors) {
						self.errors = errors;
						reloadTables();
					});
			}

			function submit(fee) {
				self.errors = null;
				return FeeSvc.submit(fee)
					.then(function (response) {
						if (angular.isObject(response.data.visits_collection)) {
							FeeSvc.showOpenVisitsModal(response.data.visits_collection)
								.then(function (result) {
									if (angular.isObject(result)) {
										if (InstanceSvc.instance.isMM()) {
											$state.go('main.merrymaids.job.close.list', result);
										}
										else if (InstanceSvc.instance.isTG()) {
											$state.go('main.trugreen.job.closeJobList', result);
										}
									}
								});
						}
						reloadTables();
					}, function (errors) {
						self.errors = errors;
					});
			}

			function confirmSlidingScaleFeeSubmission(group, date) {
				let errorMessages = [];
				let warningMessages = [];
				// let hasError = false;
				angular.forEach(group, (fee) => {
					if (!(angular.isNumber(fee.net) && angular.isObject(fee.license_breakdown))) {
						errorMessages.push({
							message: 'You must submit a net value for license ' + fee.license_number + '',
						});
					}
					if (angular.isNumber(fee.royalty_net) && fee.royalty_net < fee.minimum_fee && !fee.no_fee_applied && !fee.fee_free_period) {
						warningMessages.push(
							'A min fee of £' + fee.minimum_fee + ' + VAT has been applied for license ' + fee.license_number
						);
					}
				});

				if (errorMessages.length !== 0) {
					angular.forEach(errorMessages, (error) => {
						notify({
							message: error.message,
							classes: 'error'
						});
					});
					return;
				}

				if (warningMessages.length !== 0) {
					var messages = '';
					messages += '<b>Please review and confirm your submission by pressing "Ok"</b><br/><br/> <ul>';
					angular.forEach(warningMessages, function (message) {
						messages += '<li>' + message + '</li>';
					});
					messages += '</ul>';
					// $ngBootbox.confirm({title: 'Min fee applied', message: messages})
					return $ngBootbox.confirm(messages)
						.then(function () {
							return submitSlidingScaleFee(group, date);
						});
				}
				else {
					return submitSlidingScaleFee(group, date);
				}
			}

			function submitSlidingScaleFee(group, date) {
				return FeeSvc.submitSlidingScaleFee({fees: group})
					.then(function (response) {
						//removing submitted fee from local storage
						if (angular.isDefined($localStorage.unsubmittedCollection)) {
							angular.forEach($localStorage.unsubmittedCollection, function (localFee, key) {
								if (date == key) {
									delete $localStorage.unsubmittedCollection[key];
								}
							});
						}
						reloadTables();
					}, function (errors) {
						self.errors = errors;
					});

			}

			function addFeeDeductions(item, type = '') {
				FeeSvc.showFeeInformationModal(item)
					.then((result) => {
						angular.extend(item, result);
						reCalcWithDeductions(item);
						if(type == 'sliding'){
							$localStorage.unsubmittedSmComFeesCollection = self.unsubmittedSmComFeesCollection;
						} else {
							$localStorage.unsubmittedFeesCollection = self.unsubmittedFeesCollection;
						}
					});
			}

			function reloadTables() {
				init();
				if (angular.isDefined(self.unsubmittedTableParams)) {
					self.unsubmittedTableParams.reload();
				}
				if (angular.isDefined(self.inProgressTableParams)) {
					self.inProgressTableParams.reload();
				}
				if (angular.isDefined(self.unsubmittedSmComFeeTableParams)) {
					self.unsubmittedSmComFeeTableParams.reload();
				}
				if (angular.isDefined(self.inProgressSmComFeeTableParams)) {
					self.inProgressSmComFeeTableParams.reload();
				}
				if (angular.isDefined(self.inProgressSlidingFeeTableParams)) {
					self.inProgressSlidingFeeTableParams.reload();
				}

			}

			function onNetUpdated(item) {
				TaxHelperSvc.setVatRate()
					.then(function () {
						item.total_vat = TaxHelperSvc.vatFromNet(item.total_net);
						item.total_gross = TaxHelperSvc.grossFromNet(item.total_net);
						item.royalty_net = parseFloat((item.total_net * item.fee) / 100);
						item.royalty_vat = TaxHelperSvc.vatFromNet(item.royalty_net);
						item.royalty_gross = TaxHelperSvc.grossFromNet(item.royalty_net);

					});
			}

			function reCalcWithDeductions(item) {
				TaxHelperSvc.setVatRate()
					.then(function () {
						item.total_vat = TaxHelperSvc.vatFromNet(item.total_net);
						item.total_gross = TaxHelperSvc.grossFromNet(item.total_net);
						item.total_net_deductions = angular.isNumber(item.total_net_deductions) ? item.total_net_deductions : 0;
						item.sams_net = item.sams_net && angular.isNumber(item.sams_net) && typeof item.sams_net != 'undefined' && typeof item.sams_net != 'NaN' ? item.sams_net : 0;
						item.total_feeable_net = (parseFloat(item.total_net) + parseFloat(item.sams_net)) - parseFloat(item.total_net_deductions);
						if (item.fee_method_value == 'sliding_percent') {
							calculateBreakdown(item, item.scales);
							calculateSlidingFeeRoyalty(item);
						}
						else {
							item.royalty_net = parseFloat((item.total_feeable_net * item.fee) / 100);
							item.royalty_vat = TaxHelperSvc.vatFromNet(item.royalty_net);
							item.royalty_gross = TaxHelperSvc.grossFromNet(item.royalty_net);
						}
					});
			}

			function calculateSlidingFeeRoyalty(fee){
				fee.royalty_net = fee.royalty_net - (fee.sams_feeable || 0) ;
				fee.royalty_vat = TaxHelperSvc.vatFromNet(fee.royalty_net);
				fee.royalty_gross = TaxHelperSvc.grossFromNet(fee.royalty_net);
				if(fee.fee_free_period){
					angular.extend(fee, {
						error: 'Fee free period',
						min_fee_applied: false,
					});
				}
				else if (InstanceSvc.instance.isRB() && ((angular.isNumber(fee.royalty_net) && fee.royalty_net < fee.minimum_fee && !fee.no_fee_applied) || fee.age_in_months <= 6)) {
					angular.extend(fee, {
						error: 'Min Fee Applied £' + fee.minimum_fee,
						min_fee_applied: true,
						min_fee_vat: TaxHelperSvc.vatFromNet(fee.minimum_fee),
						min_fee_gross: TaxHelperSvc.grossFromNet(fee.minimum_fee)
					});
				}
				else {
					angular.extend(fee, {
						error: '',
						min_fee_applied: false
					});
				}

			}

			function updateSlidingPercentFee(groupedFee) {
				TaxHelperSvc.setVatRate()
					.then(function () {

						let scalesCopy = angular.copy(self.scales);
						angular.forEach(groupedFee, (fee) => {
							if($scope.isSM()){
								scalesCopy = angular.copy(self.scales);
							}
							calculateBreakdown(fee, scalesCopy);
							calculateSlidingFeeRoyalty(fee);
						});
					});
			}

			function calculateBreakdown(fee, scalesCopy) {

				fee.feeRemainder = parseFloat(fee.total_feeable_net) || 0;
				fee.feeBreakdown = [];
				fee.royalty_net = 0;

				if($scope.isCS() || $scope.isRB()){
					fee.vat = TaxHelperSvc.vatFromNet(fee.total_feeable_net) || 0;
					fee.gross = TaxHelperSvc.grossFromNet(fee.total_feeable_net) || 0;
					fee.total_net = fee.net;
					fee.total_vat = fee.vat;
					fee.total_gross = fee.gross;
				}
				if($scope.isSM()){
					scalesCopy = angular.copy(scalesCopy);
				}
				angular.forEach(scalesCopy, (scale) => {
					if (angular.isUndefined(scale.allocatableRemainder)) {
						scale.allocatableRemainder = parseFloat(scale.allocatable);
					}

					if (scale.allocatableRemainder > 0) {
						let allocation = Math.min(fee.feeRemainder, scale.allocatableRemainder);
						scale.allocatableRemainder -= allocation;
						fee.feeRemainder -= allocation;
						let allocationRoyaltyNet = allocation * scale.percentage / 100;
						fee.royalty_net += allocationRoyaltyNet;
						fee.royalty_vat = TaxHelperSvc.vatFromNet(fee.royalty_net);
						fee.royalty_gross = TaxHelperSvc.grossFromNet(fee.royalty_net);
						// if(fee.fee_free_period){
						// 	angular.extend(fee, {
						// 		error: 'Fee free period',
						// 		min_fee_applied: false,
						// 	});
						// }
						// else if (((angular.isNumber(fee.royalty_net) && fee.royalty_net < fee.minimum_fee && !fee.no_fee_applied) || (fee.age_in_months <= 6 && fee.no_fee_applied)) && InstanceSvc.instance.isRB()) {
						// 	angular.extend(fee, {
						// 		error: 'Min Fee Applied £' + fee.minimum_fee,
						// 		min_fee_applied: true,
						// 		min_fee_vat: TaxHelperSvc.vatFromNet(fee.minimum_fee),
						// 		min_fee_gross: TaxHelperSvc.grossFromNet(fee.minimum_fee)
						// 	});
						// }
						// else {
						// 	angular.extend(fee, {
						// 		error: '',
						// 		min_fee_applied: false
						// 	});
						// }

						let feeBreakdownItem = {
							percentage: scale.percentage,
							royalty_net: allocationRoyaltyNet,
							allocation: allocation,
						};
						fee.feeBreakdown.push(feeBreakdownItem);
					}
				});
			}

			function calculateNetModal(fee, groupedFee, readonly) {
				FeeSvc.showLicenseBreakdownModal(fee, readonly)
					.then((result) => {
						angular.extend(fee, result);
						angular.extend(fee, {
							total_feeable_net: result.license_breakdown.total_fee,
							net: result.license_breakdown.total_fee,
						});
						updateSlidingPercentFee(groupedFee);
						$localStorage.unsubmittedCollection = self.unsubmittedCollection;
					});
			}

			function showSlidingFeeBreakdownModal(fee, groupedFee, scales, readonly) {
				FeeSvc.showSlidingFeeBreakdownModal(fee, scales, readonly)
					.then((result) => {
						angular.extend(fee, result);
						angular.extend(fee, {
							total_feeable_net: result.license_breakdown.total_fee,
							net: result.license_breakdown.total_fee,
						});
						updateSlidingPercentFee(groupedFee);
					});
			}

			function showFeeBreakdown(fee) {
				FeeSvc.showFeeBreakdownModal(fee)
					.then((result) => {
					});
			}

			function showRejectionReason(fee) {
				$ngBootbox.alert(fee.rejection_reason);
			}

			var self = $scope.FeeIndexCtrl = {
				counts: {
					unsubmitted: null,
					inProgress: null,
					approved: null
				},
				loading: {
					unsubmitted: true,
					inProgress: true,
					approved: true
				},
				methods: {
					init: init,
					submit: submit,
					reject: reject,
					onNetUpdated: onNetUpdated,
					updateSlidingPercentFee: updateSlidingPercentFee,
					submitSlidingScaleFee: submitSlidingScaleFee,
					confirmSlidingScaleFeeSubmission: confirmSlidingScaleFeeSubmission,
					calculateNetModal: calculateNetModal,
					showSlidingFeeBreakdownModal: showSlidingFeeBreakdownModal,
					showFeeBreakdown: showFeeBreakdown,
					addFeeDeductions: addFeeDeductions,
					reCalcWithDeductions: reCalcWithDeductions,
					showRejectionReason: showRejectionReason,
				}
			};

		}
	]);
